import Main from '@/views/administracion/presupuestos/Main.vue';
import Default from '@/views/administracion/presupuestos/Default.vue';

const auth = ['Presupuestos:ver'];
const scopes = ['Presupuestos:crear', 'Presupuestos:editar', 'Presupuestos:eliminar'];

const presupuestos = [
  {
    path: 'presupuestos',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'presupuestos',
        path: '/',
        meta: {
          title: 'Presupuestos',
          auth,
          scopes,
        },
        component: Default,
        children: [],
      },
    ],
  },
];

export default presupuestos;
